import React, { Component } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import Checkup from "../components/checkup"
import Company from "../components/companys"
import rightArrow from "../assets/img/right-arrow.png"
import checkModal from "../assets/img/check-modal.png"
import lion from "../assets/img/produksiyon-ust-gorsel.webp"
import balance from "../assets/img/balance-time-money.png"
import achievement from "../assets/img/achievement-female.png"
import videoSearch from "../assets/img/video-search.png"
import cv from "../assets/img/cv-curriculum.png"
import work from "../assets/img/work-preformance.png"
import tipsContent1 from "../assets/img/aida-prod-alt-gorsel.webp"
import tipsContent2 from "../assets/img/arcadium-prod-alt-gorsel.webp"
import tipsContent3 from "../assets/img/kentpark-prod-alt-gorsel.webp"
import tipsContent4 from "../assets/img/lova-prod-alt-gorsel.webp"

class ProductionService extends Component {
  constructor(props) {
    super(props)
    this.state = {
      display: false,
      value: "",
    }
    this.handleChange = this.handleChange.bind(this)
  }

  handleChange(e) {
    e.preventDefault()
    this.setState({ value: e.target.value })
  }

  showModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.add("active-modal")
  }

  closeModal() {
    this.setState({ display: !this.state.display })
    document.querySelector(".check-modal").classList.remove("active-modal")
  }

  handleSubmit(e) {
    e.preventDefault()
    const title = document.title.split("|", 1).toString()
    const response = fetch("https://forms.flatart.com.tr/index.php?r=app%2Ff&id=7", {
      method: "POST",
      body: JSON.stringify({
        text_327649: title,
        text_204202: document.querySelector("#site").value,
        text_775908: document.querySelector("#name").value,
        text_532192: document.querySelector("#email").value,
      }),
      headers: { "Content-type": "application/json; charset=UTF-8" },
    })
    response.then(res => {
      if (res.status === 200) {
        document.querySelector(".status").innerHTML = "Your message has been sent successfully."
      } else {
        document.querySelector(".status").innerHTML = "An error occurred."
      }
    })
  }

  render() {
    return (
      <Layout>
        <SEO
          title="Production Service | Video & Content Production | Flatart"
          description="Flatart's production service covers concept development, shooting, and post-production. We create high-quality video and visual content for your brand."
        />

        <div className="seo-service container">
          <div className="seo-service__head custom">
            <div className="col-md-6">
              <h1>Production Service</h1>
              <span className="red-head">SERVICES</span>
              <p>From concept to final delivery — we create compelling video and visual content that tells your brand's story and drives results.</p>
              <input
                type="text"
                className="pink-input"
                placeholder="Enter your e-mail address"
                value={this.state.value}
                onChange={this.handleChange}
              />
              <button className="red-button" onClick={() => this.showModal()}>
                Get your special offer
              </button>
            </div>
            <div className="col-md-6 seo-top-right">
              <img alt="Production Service" src={lion} />
            </div>
            <div className="check-modal">
              <span onClick={() => this.closeModal()}>X</span>
              <h2 className="form-head">Fill the form</h2>
              <p className="form-desc">Enter your information in the fields to get information, and we will get back to you as soon as possible.</p>
              <div className="check-modal_container">
                <form onSubmit={e => this.handleSubmit(e)}>
                  <input type="text" name="text_204202" id="site" required placeholder="Enter your website." />
                  <input type="text" id="name" required name="text_775908" placeholder="Enter your name" />
                  <input type="email" id="email" required name="text_532192" value={this.state.value} onChange={this.handleChange} autoFocus={true} placeholder="Enter your email" />
                  <button>SEND</button>
                  <div className="status"></div>
                </form>
                <img alt="" src={checkModal} />
              </div>
            </div>
          </div>
        </div>

        <div className="container brands_content py30">
          <div className="studies">
            <h2>Trusted by leading brands — we bring their stories to life through premium production.</h2>
          </div>
          <h2 className="py60">Our References</h2>
          <p>Brands we've produced content for.</p>
          <div className="companys__social">
            <Company />
          </div>
        </div>

        <div className="acquire-bottom social-media-contents">
          <div className="seo-services container" style={{ background: "#f4f4f4", borderRadius: 10 }}>
            <div className="seo-services_head" style={{ marginTop: 30, marginBottom: 50 }}>
              <h2>Why choose Flatart for production?</h2>
            </div>
            <div className="seo-services_content py60">
              <div className="col-md-12 content-list">
                <div className="col-md-4 audits-info">
                  <img alt="" src={balance} style={{ width: 90 }} />
                  <h3 style={{ fontWeight: 500, fontSize: 23 }}>Creative Direction</h3>
                  <p style={{ fontSize: 16 }}>We develop concepts and creative strategies that align with your brand identity and campaign objectives.</p>
                </div>
                <div className="col-md-4 audits-info">
                  <img alt="" src={achievement} style={{ width: 90 }} />
                  <h3 style={{ fontWeight: 500, fontSize: 23 }}>End-to-End Production</h3>
                  <p style={{ fontSize: 16 }}>From pre-production planning to post-production editing, we handle every step of the production process.</p>
                </div>
                <div className="col-md-4 audits-info">
                  <img alt="" src={videoSearch} style={{ width: 90 }} />
                  <h3 style={{ fontWeight: 500, fontSize: 23 }}>Platform-Optimized Content</h3>
                  <p style={{ fontSize: 16 }}>We produce content optimized for each platform — social media, TV, digital ads, and more.</p>
                </div>
              </div>
              <div className="col-md-12 content-list" style={{ marginTop: 30 }}>
                <div className="col-md-4 audits-info">
                  <img alt="" src={cv} style={{ width: 90 }} />
                  <h3 style={{ fontWeight: 500, fontSize: 23 }}>Data-Driven Storytelling</h3>
                  <p style={{ fontSize: 16 }}>We combine creative storytelling with performance data to create content that resonates and converts.</p>
                </div>
                <div className="col-md-4 audits-info">
                  <img alt="" src={work} style={{ width: 90 }} />
                  <h3 style={{ fontWeight: 500, fontSize: 23 }}>Professional Equipment</h3>
                  <p style={{ fontSize: 16 }}>State-of-the-art cameras, lighting, and audio equipment to ensure the highest production quality.</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="container py60">
          <h2 style={{ textAlign: "center", marginBottom: 40 }}>Production Gallery</h2>
          <div className="col-md-12 content-list">
            <div className="col-md-3">
              <img alt="Production Sample 1" src={tipsContent1} style={{ width: "100%", borderRadius: 8 }} />
            </div>
            <div className="col-md-3">
              <img alt="Production Sample 2" src={tipsContent2} style={{ width: "100%", borderRadius: 8 }} />
            </div>
            <div className="col-md-3">
              <img alt="Production Sample 3" src={tipsContent3} style={{ width: "100%", borderRadius: 8 }} />
            </div>
            <div className="col-md-3">
              <img alt="Production Sample 4" src={tipsContent4} style={{ width: "100%", borderRadius: 8 }} />
            </div>
          </div>
        </div>

        <Checkup />

        <div className="onboarding container py60">
          <div className="col-md-4">
            <img alt="" src={work} />
            <h2>Our production<br />process.</h2>
            <p>Take a look at how we run our production process for our brands.</p>
          </div>
          <div className="col-md-8">
            <div className="hiring-tabs">
              <input type="checkbox" name="onboarding" id="tab1" />
              <input type="checkbox" name="onboarding" id="tab2" />
              <input type="checkbox" name="onboarding" id="tab3" />
              <input type="checkbox" name="onboarding" id="tab4" />
              <input type="checkbox" name="onboarding" id="tab5" />
              <input type="checkbox" name="onboarding" id="tab6" />

              <div className="tab" id="tab1sec">
                <label htmlFor="tab1"> </label>
                <h3><span>1</span> Discovery Meeting</h3>
                <p>- We start with a meeting to understand your brand, campaign goals, target audience, and the message you want to communicate through video and visual content.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab2sec">
                <label htmlFor="tab2"> </label>
                <h3><span>2</span> Concept &amp; Script Development</h3>
                <p>- Our creative team develops concepts, scripts, and storyboards that bring your vision to life in an engaging way.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab3sec">
                <label htmlFor="tab3"> </label>
                <h3><span>3</span> Pre-Production &amp; Equipment Planning</h3>
                <p>- We handle all logistics — location scouting, talent casting, equipment preparation, and production scheduling to ensure a smooth shoot.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab4sec">
                <label htmlFor="tab4"> </label>
                <h3><span>4</span> Shooting</h3>
                <p>- Our professional crew executes the shoot with precision, capturing all necessary footage and assets per the approved plan.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab5sec">
                <label htmlFor="tab5"> </label>
                <h3><span>5</span> Post-Production &amp; Revisions</h3>
                <p>- Editing, color grading, sound design, and motion graphics are applied. We work through revision rounds until you're fully satisfied with the result.</p>
                <div className="plus"></div>
              </div>
              <div className="tab" id="tab6sec">
                <label htmlFor="tab6"> </label>
                <h3><span>6</span> Final Delivery &amp; Distribution</h3>
                <p>- We deliver final files in all required formats and provide recommendations on how to maximize the content's performance across platforms.</p>
                <div className="plus"></div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    )
  }
}

export default ProductionService
